import { isVariableDefinedNotNull, urlParam } from '@slideslive/fuse-kit/utils';

import MockDataFetcher from './mock_data_fetcher';
import RealDataFetcher from './real_data_fetcher';

function useMockDataFetcher() {
  if (urlParam('use_mock_data') === 'true') return true;

  if (isVariableDefinedNotNull(urlParam('nate_runner_host'))) return false;
  if (urlParam('use_real_data') === 'true') return false;
  if (import.meta.env.PROD) return false;

  return true;
}

export default class DataFetcher {
  constructor(fetcher = null) {
    const defaultFetcher = useMockDataFetcher() ? new MockDataFetcher() : new RealDataFetcher();

    this.fetcher = fetcher || defaultFetcher;

    console.info(`DataFetcher using: ${this.fetcher.constructor.name}`);
  }

  buildUrl(path) {
    return typeof this.fetcher.buildUrl === 'function' ? this.fetcher.buildUrl(path) : String(path || '');
  }

  get(...args) {
    return this.fetcher.get(...args);
  }

  post(...args) {
    return this.fetcher.post(...args);
  }

  patch(...args) {
    return this.fetcher.patch(...args);
  }

  put(...args) {
    return this.fetcher.put(...args);
  }

  delete(...args) {
    return this.fetcher.delete(...args);
  }
}
